/**
 * CREATIVE DETONATOR - Generator Utilities
 * Shared helper functions used across multiple modules
 */

// ============================================================================
// CLIPBOARD UTILITIES
// ============================================================================

/**
 * Copy text to clipboard with button feedback
 * @param {string} text - The text to copy
 * @param {HTMLElement} button - The button element to show feedback on
 */
export function copyToClipboardWithFeedback(text, button) {
  navigator.clipboard.writeText(text).then(() => {
    // Visual feedback
    const originalText = button.querySelector('span')?.textContent || 'COPY';
    button.classList.add('copied');
    const span = button.querySelector('span');
    if (span) span.textContent = 'COPIED!';

    // Reset after delay
    setTimeout(() => {
      button.classList.remove('copied');
      if (span) span.textContent = originalText;
    }, 2000);
  }).catch(err => {
    console.error('Failed to copy:', err);
  });
}

// ============================================================================
// FORMAT UTILITIES
// ============================================================================

/**
 * Get format icon path
 * @param {string} format - The format name (social, video, print, etc.)
 * @returns {string} The path to the format icon image
 */
export function getFormatIconPath(format) {
  // Map format names to their 8-bit pixel art icon files
  const iconPaths = {
    'social': '/assets/images/formats/1-social-media.png',
    'video': '/assets/images/formats/2-video-ad.png',
    'print': '/assets/images/formats/3-ooh-media.png',
    'ooh': '/assets/images/formats/3-ooh-media.png',
    'experiential': '/assets/images/formats/4-experimental.png',
    'digital': '/assets/images/formats/5-digital.png',
    'campaign': '/assets/images/formats/6-full-campaign.png'
  };
  return iconPaths[format] || iconPaths['print'];
}

// ============================================================================
// GLOBAL EXPORTS FOR COMPATIBILITY
// ============================================================================

// Expose to window for compatibility with non-module code
window.copyToClipboardWithFeedback = copyToClipboardWithFeedback;
window.getFormatIconPath = getFormatIconPath;
